
import hero_img3 from "../assets/images/hero-image3.png";

export default function AboutPreview() {

  return (
    <>
      {/* <!-- عن الشركة --> */}
      <section className="bg-gray-50 py-20" dir="rtl">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            {/* الصورة */}
            <div className="relative">
              <div className="overflow-hidden rounded-3xl">
                <img
                  src={hero_img3}
                  alt="خبراء التدوير"
                  className="h-[420px] w-full object-cover transition duration-500 hover:scale-105"
                />
              </div>

              {/* العنصر الجانبي */}
              <div className="absolute -bottom-6 -right-6 hidden rounded-2xl bg-white p-6 shadow-xl sm:block">
                <div className="text-3xl font-bold text-green-600">2004</div>

                <div className="mt-1 text-sm text-gray-600">بداية المسيرة</div>
              </div>
            </div>

            {/* المحتوى */}
            <div>
              <span className="mb-3 block text-sm font-semibold text-green-600">
                من نحن
              </span>

              <h2 className="mb-6 text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
                خبراء في إعادة التدوير
                <br />
                وشريك في الاستدامة
              </h2>

              <p className="mb-5 text-lg leading-8 text-gray-600">
                نعمل في مجال إعادة التدوير ونقدم حلولًا متكاملة تساعد الشركات
                والمنشآت على إدارة المواد القابلة لإعادة التدوير بكفاءة
                واستدامة.
              </p>

              <p className="mb-8 leading-7 text-gray-500">
                نسعى إلى تقديم حلول عملية تساهم في المحافظة على البيئة وتحسين
                كفاءة عمليات إعادة التدوير، مع بناء علاقات طويلة الأمد مع
                عملائنا وشركائنا.
              </p>

              {/* المميزات */}
              <div className="mb-8 grid gap-4 sm:grid-cols-2">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600">
                    ✓
                  </span>

                  <span className="font-medium text-gray-700">
                    خبرة في مجال إعادةالتدوير
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600">
                    ✓
                  </span>

                  <span className="font-medium text-gray-700">
                    حلول متكاملة
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600">
                    ✓
                  </span>

                  <span className="font-medium text-gray-700">
                    اهتمام بالاستدامة
                  </span>
                </div>

                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600">
                    ✓
                  </span>

                  <span className="font-medium text-gray-700">
                    شراكات طويلة الأمد
                  </span>
                </div>
              </div>

              {/* الزر */}
              <a
                href="/about"
                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-7 py-3.5 font-semibold text-white transition duration-300 hover:bg-green-700"
              >
                تعرف علينا أكثر
                <span>←</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
